import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
      private router: Router,
      private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this.authService.currentUserValue;
    this.authService.fetchLatestUser().subscribe();
    if (currentUser) {
      // if (!currentUser.emailVerified) {
      //   if (state.url === '/auth/twostep') {
      //     return true;
      //   }
      //   this.router.navigate(['/auth/twostep']);
      //   return false;
      // }


      if (currentUser.role=='Teacher' && !currentUser.teacher_profile) {
        if (state.url === '/profile/teacher-profile') {
          return true;
        }
        this.router.navigate(['/profile/teacher-profile']);
        return false;
      }

      return true;
    }

    // Not logged in so redirect to login page with the return url
    this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    return false;
    

  }
}

